import { FC } from 'react';
import { DescriptorKeyType } from '../Types';
import BaseViewModel from '../Models/BaseViewModel';
import FieldGroup from './FieldGroup/FieldGroup';
import InputNumber from './InputNumber/InputNumber';
import FeedbackMessage from './FeedBackMessage/FeedbackMessage';
import Collapsed from './Collapsed/Collapsed';
import EnumControl from './EnumControl';
import CheckBoxText from './CheckBox';
import Placeholder from './Placeholder';
import TextControl from './TextControl';
import DateControl from './DateControl';
import FormControl from './FormControl';
import TitleControl from './TitleControl';
import FiasRegionSelectControl from './FiasRegionSelectControl';
import DictionaryRegistryControl from './DictionaryRegistryControl';
import FloatControl from './FloatControl';
import IntegerControl from './IntegerControl';
import UuidControl from './UuidControl';
import CurrentUserControl from './CurrentUserControl';
import CustomerSelectControl from './CustomerSelectControl';
import UserInfoListControl from './UserInfoListControl';
import PageContainerControl from './PageContainerControl';
import PageControl from './PageControl';
import SimpleAttachmentControl from './FileInput/SimpleAttachmentControl';
import CollectionFormControl from './CollectionFormControl';

export type FieldTypes =
	| 'SimpleText'
	| 'number'
	| 'date'
	| 'time'
	| 'mask'
	| 'bool'
	| 'OnlyCaption'
	| 'InPlaceCollapsedView';

export interface IFormProps {
	model: BaseViewModel;
	readOnly?: boolean;
	setFieldValue: (fieldName: string, value: any) => void;
}

const getFieldComponent = (descriptorKey: DescriptorKeyType): React.FC<any> => {
	switch (descriptorKey) {
		case DescriptorKeyType.FloatControlDescriptor:
			return FloatControl;
		case DescriptorKeyType.BoolControlDescriptor:
			return CheckBoxText;
		case DescriptorKeyType.TextControlDescriptor:
			return TextControl;
		case DescriptorKeyType.DateControlDescriptor:
			return DateControl;
		case DescriptorKeyType.TitleControlDescriptor:
			return TitleControl;
		case DescriptorKeyType.FormDescriptor:
			return FormControl;
		case DescriptorKeyType.EnumControlDescriptor:
			return EnumControl;
		case DescriptorKeyType.IntegerControlDescriptor:
			return IntegerControl;
		case DescriptorKeyType.CurrentUserViewModel:
			return CurrentUserControl;
		case DescriptorKeyType.UuidControlDescriptor:
			return UuidControl;
		case DescriptorKeyType.DictionaryRegistryControlDescriptor:
			return DictionaryRegistryControl;
		case DescriptorKeyType.UserInfoList:
			return UserInfoListControl;
		case DescriptorKeyType.CustomerSelect:
			return CustomerSelectControl;
		case DescriptorKeyType.PageContainerControlDescriptor:
			return PageContainerControl;
		case DescriptorKeyType.PageDescriptor:
			return PageControl;
		case DescriptorKeyType.CollectionFormDescriptor:
			return CollectionFormControl;
		case DescriptorKeyType.SimpleAttachmentViewModel:
			return SimpleAttachmentControl;

		case DescriptorKeyType.FiasRegionSelectControlViewModel:
		case DescriptorKeyType.FIAS:
			return FiasRegionSelectControl;

		default:
			return Placeholder;
	}
};

export {
	FormControl,
	FeedbackMessage,
	FieldGroup,
	Collapsed,
	InputNumber,
	EnumControl,
	CheckBoxText,
};

export default getFieldComponent;
